/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IntegrationsControllerConnectToProviderMutationResponse, IntegrationsControllerConnectToProviderPathParams } from "../../models/integrationsController/IntegrationsControllerConnectToProvider";

function getIntegrationsControllerConnectToProviderUrl(provider: IntegrationsControllerConnectToProviderPathParams["provider"]) {
  const res = { method: 'POST', url: `/api/v1/integrations/${provider}` as const }  
  return res
}

/**
 * @summary Accepts authorization code from provider and exchanges it for access and refresh tokens
 * {@link /api/v1/integrations/:provider}
 * @deprecated
 */
export async function integrationsControllerConnectToProvider(provider: IntegrationsControllerConnectToProviderPathParams["provider"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IntegrationsControllerConnectToProviderMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getIntegrationsControllerConnectToProviderUrl(provider).url.toString(), ... requestConfig })  
  return res.data
}